export default class ZigZag {
    constructor() {
        this.sections = document.querySelectorAll('.component-zig-zag');
        console.log('ZigZag component initialized');

        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            const buttons = section.querySelectorAll('.zigZagButton');

            buttons.forEach((button) => {
                const dropdown = button.querySelector('ul');

                button.addEventListener('click', (e) => {
                    e.stopPropagation();

                    // Fecha todos os outros dropdowns
                    this.closeAllDropdownsExcept(dropdown);

                    // Alterna a visibilidade do atual
                    if (dropdown) {
                        dropdown.classList.toggle('hidden');
                    }
                });
            });
        });

        // Fecha todos os dropdowns ao clicar fora
        document.addEventListener('click', () => {
            this.closeAllDropdownsExcept(null);
        });
    }

    closeAllDropdownsExcept(current) {
        // Fecha todos os <ul> dentro de .zigZagButton
        document.querySelectorAll('.zigZagButton ul').forEach((el) => {
            if (el !== current) {
                el.classList.add('hidden');
            }
        });
    }
}

if (document.querySelector('.component-zig-zag')) {
    new ZigZag();
}
